import { service } from './service'

import { config } from './config'
import utils from '@/utils/cookie'

import qs from 'qs'
import { useAuthStoreWithOut } from '@/store/modules/auth'
import { useCommonStoreWithOut } from '@/store/modules/common'
const commonStore = useCommonStoreWithOut()
const authStore = useAuthStoreWithOut()
const { default_headers } = config
const DOMAIN_KEY = 'portal'
export function getBaseURL (baseUrl) {
  let url = (window as any).$ikorigin
  if ((window as any).$ikorigin.search(DOMAIN_KEY) !== -1) {
    const reg = new RegExp('-\\d+-\\d+-\\d+')
    url = url.replace(reg, '')
    if (baseUrl=='apm-core') {
      url = url.replace('portal-iknowledge', 'portal-apm')
      url += '/api-apm'
    } else if(baseUrl=='agent') {
      if ((window as any).env.AGENT_BACKEND) url = (window as any).env.AGENT_BACKEND
      else if (commonStore.getAgentSettings) url = commonStore.getAgentSettings.url
      else url = url.replace('portal-iknowledge', 'chat-agent')
    } else if(baseUrl=='api-desk') {
      url = url.replace('portal-iknowledge', 'desk-customization')
    } else if (baseUrl=='deskapp') {
      url = url.replace('portal-iknowledge', 'desk-app-management')
    } else if(baseUrl=='m2i') {
      url = url.replace('portal-iknowledge', 'api-m2i')
      url += '/m2i'
    } else {
      if ((window as any).env.BACKEND) url = (window as any).env.BACKEND
      else url = url.replace('portal-iknowledge', 'api-iknowledge')
    }
    return url
  } else {
    if (baseUrl=='agent') {
      if ((window as any).env.AGENT_BACKEND) url = (window as any).env.AGENT_BACKEND
      else if (commonStore.getAgentSettings) url = commonStore.getAgentSettings.url
      else url = baseUrl
      return url
    }
  }
  return baseUrl
}

const request = (option: any) => {
  const { url, method, params, data, headersType, responseType, baseUrl, header, timeout } = option
  // console.log('baseUrl', baseUrl)
  const headers = header?header:{}
  if (process.env.NODE_ENV !== 'production') {
    headers['org-id'] = authStore.getOrgInfo.id
  } else {
    // ik的后台会根据cookie中携带的OrgId获取OrgId
    if (![undefined,null,''].includes(baseUrl) && !headers['org-id'] && headers['org-id'] !== 0) {
      let orgId = authStore.getOrgInfo.id
      if ((window as any).$wujie) orgId = (window as any).$wujie.props.orgInfo.id
      headers['org-id'] = orgId
    }
  }
  
  if (!headers['Tenant-Id'] && ['deskapp','api-desk'].includes(baseUrl)) {
    if ((window as any).$wujie && (window as any).$wujie.props.tenantId) {
      const tenantId = (window as any).$wujie.props.tenantId
      headers['Tenant-Id'] = tenantId
    } else if (utils.getCookie('tenantId')) {
      console.log('get tenantId from Cookie:', utils.getCookie('tenantId'))
      headers['Tenant-Id'] = utils.getCookie('tenantId')
    } else {
      headers['Tenant-Id'] = '9eac64c330a5457a8f20b88f7279029b'
    }
  }

  return service({
    baseURL:getBaseURL(baseUrl),
    url: url,
    method,
    params,
    data,
    responseType: responseType,
    withCredentials: true,
    timeout: timeout,
    headers: {
      'Content-Type': headersType || default_headers,
      ...headers
    },
    paramsSerializer : params => {
      return qs.stringify(params, { indices: false })
    }  
  })
}
export default {
  get: <T = any>(option: any) => {
    return request({ method: 'get', ...option }) as unknown as T
  },
  post: <T = any>(option: any) => {
    return request({ method: 'post', ...option }) as unknown as T
  },
  delete: <T = any>(option: any) => {
    return request({ method: 'delete', ...option }) as unknown as T
  },
  put: <T = any>(option: any) => {
    return request({ method: 'put', ...option }) as unknown as T
  }
}
